<template>
    <div class="menu-left" :class="{active}">
        <ul class="menu">
            <router-link class="item" tag="li" to="/" exact>
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Inicio</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="usar-el-cinturon">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Usar el cinturón</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="respetar-las-reglas">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Respetar las reglas</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="reducir-la-velocidad">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Reducir la velocidad</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="proteger-a-los-ninos">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Proteger a los niños</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="prestar-atencion">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Prestar atención</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="manejar-descansado">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Manejar descansado</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="usar-casco">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Usar casco</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="ser-cortes">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Ser cortés</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="revisar-el-auto">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Revisar el auto</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="consejos-adicionales">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Consejos</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="certificado-gxsv">
                <div class="content">
                    <span class="icon"><i class="fa fa-circle-o"></i></span>
                    <span>Certificado gxsv</span>
                </div>
            </router-link>
            <li class="close" @click="signOut" v-if="showCloseSession">
                <div class="content">
                    <span class="icon">
                        <i class="fa fa-power-off"></i>
                    </span>
                    <span>
                        Salir
                    </span>
                </div>
            </li>
        </ul>
        <div class="back-menu"></div>
    </div>
</template>

<script>
    export default {
        name: 'side-bar-left',
        data() {
            return {
                showCloseSession: false,
                active: false
            }
        },
        mounted() {
            this.showCloseSession = !!this.$store.state.api_token
            console.log(localStorage.getItem('api_token'))
            this.$store.subscribe((mutation, state) => {
                this.showCloseSession = !!state.api_token
            })
        },
        methods: {
            signOut() {
                this.$emit('sign-out')
            }
        },
        watch: {
            '$route'() {
                this.active = true;
                setTimeout(() => {
                    this.active = false;
                }, 2000)
            }
        }
    };
</script>

<style lang="sass" scoped>

    .menu-left
        position: relative
        max-height: 100%
        overflow-y: auto
        max-width: 100%
        overflow-x: hidden
        top: 50%
        transform: translateY(-50%)
        height: auto
        min-height: 1px
        transition: all 2s ease-in-out
        &:hover, &.active
            ul.menu
                background: rgba(0, 0, 0, .2)
                width: auto
                li
                    span
                        &:not(.icon)
                            display: inline-block
        ul.menu
            list-style: none
            padding-left: 0
            max-height: 100%
            transition: all .4s ease-in-out
            width: 33px
            overflow: hidden
            max-width: 100%
            margin: 0
            li
                color: white
                cursor: pointer
                font-size: 1.1em
                text-transform: uppercase
                padding: 5px 5px
                transition: all .4s ease-in-out
                max-width: 100%
                &:hover, &.active
                    background: rgba(0, 0, 0, .4)
                    .icon
                        .fa
                            transform: scale(1.2)
                &.item
                    &:hover, &.active
                        .icon
                            .fa
                                &::before
                                    content: '\f111'
                .icon
                    padding: 2px
                    text-align: center
                    display: inline-block
                    margin-right: 5px
                    margin-left: 5px
                span
                    display: inline-block
                    .fa
                        transition: all .4s ease-in-out
                        transform-origin: center
                    &:not(.icon)
                        transition: all .4s ease-in-out
                        display: none

</style>
